<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/about.jpg">
    </div>
    <div class="us-box">
      <div class="wrap">
        <div class="title">
          <h3>关于我们</h3>
          <p>云洋科技拥有20多年的互联网行业经验，是全国领先的企业数字门户服务商，为企业级客户提供行业化的数字营销、业务经营相
            关的产品与服务，帮助企业打造全域数字化营销与数字化业务的一站式平台。</p>
          <p>云洋科技所提供的服务可以有效解决企业基于互联网环境，企业数字化经营中从“营销数字化→交易数字化→客户经营数字化“的
            全生命周期服务，帮助企业以更低的成本、更高的效率、更快的反应提升经营效果。</p>
        </div>
        <div class="list-box">
          <div class="item">
            <h3>快交付</h3>
            <span>基于丰富的经验和产品模型，交付速度高于市面上95%服务商，甚至超客户预期</span>
          </div>
          <div class="item">
            <h3>成本低</h3>
            <span>降低客户购买、使用、学习、运营的各 方面成本</span>
          </div>
          <div class="item">
            <h3>定制化</h3>
            <span>总结了主流行业近百个细分行业，可以为客户快速提供基于行业个性特征的定制化解决方案</span>
          </div>
          <div class="item">
            <h3>全周期</h3>
            <span>基于客户整个生命周期的数字化智能服务，帮助企业实现对用户的数据化管理和营销</span>
          </div>
        </div>
      </div>
    </div>
    <CoreAdvantages/>
  </div>
</template>

<script>
import CoreAdvantages from '@/components/CoreAdvantages.vue';

export default {
  components: { CoreAdvantages},
  name: 'AboutUs',  // 组件名称
};
</script>

<style scoped>
.us-box{
  padding: 60px 0 80px 0;
  background: #f6f6f6;
}

.us-box .title h3{
  font-size: 24px;
  text-align: center;
}
.us-box .title p{
  font-size: 16px;
  margin: 30px 0;
}
.list-box{
  display: flex;
  flex-wrap: wrap;
  gap: 30px; /* 使用gap属性设置间距 */
}
.list-box .item{
   flex: 1 1 calc(50% - 30px);  /* 或者使用 width: 33.333%; */
   box-sizing: border-box; /* 确保padding和border不会影响宽度计算 */
   padding: 20px;
   background: #fff;
   border-radius: 15px;
   border: 1px solid #dfdfdf;
}
.list-box .item h3{
  font-size: 24px;
  margin-bottom: 10px;
}
.list-box .item span{
  font-size: 16px;
}
.banner{
  width: 100%;
}
.banner img{
  display: block;
  width: 100%;
}
</style>
